import Vue from "vue";
import BaseEntity from "../base/BaseEntity";
import Tank from "../tank/Tank";
import UserRole from "./UserRole";
import {validateEmail} from "../../../common/filter/validate";
import Menu from "../lover/Menu";
import {str2Date} from "../../filter/time";
import Filter from "../base/Filter";
import Captcha from "../common/Captcha";

let Status = {
	OK: "OK",
	ERROR: "ERROR"
};
export default function User() {

	//extend BaseEntity's Attributes.
	BaseEntity.call(this, arguments);

	this.role = new UserRole();

	this.email = null;
	this.password = null;
	this.nickname = null;
	this.description = null;
	this.gender = null;
	this.phone = null;
	this.city = null;
	this.avatar = new Tank("image", false);
	this.lastIp = null;
	this.lastTime = null;

	//local fields.
	this.isLogin = false;
	this.token = null;
	this.repassword = null;

	//local fields.
	this.byMenus = [];

	//TODO: 这个地方的captcha会被渲染成 Object.尚未搞清楚状况。
	this.captcha = new Captcha();
}


//extend BaseEntity
User.prototype = new BaseEntity();
User.prototype.constructor = User;
User.prototype.TAG = "user";
User.prototype.TAGS = "users";
User.prototype.URL_CREATE = "/user/create";
User.prototype.URL_DEL = "/user/del/{id}";
User.prototype.URL_EDIT = "/user/edit";
User.prototype.URL_DETAIL = "/user/detail/{id}";
User.prototype.URL_PAGE = "/user/page";
User.prototype.URL_LOGIN = "/user/login";
User.prototype.URL_REGISTER = "/user/register";

User.prototype.Status = Status;

User.prototype.getFilters = function () {
	return [
		new Filter("SORT", "ID", "orderId"),
		new Filter("SORT", "上次登录", "orderLastTime"),
		new Filter("INPUT", "关键字", "keyword"),
		new Filter("INPUT", "名字", "nickname")
	];
};


User.prototype.refreshMenus = function () {
	this.refreshByMenus();
};

User.prototype.refreshByMenus = function () {
	this.byMenus = [];

	let indexMenu = new Menu("首页", "/cgd/by/index", false, "fa fa-dashboard");
	this.byMenus.push(indexMenu);


	/**************文章****************/
	let articleMenu = new Menu("文章", "/cgd/by/article/list", false, "fa fa-newspaper-o");
	this.byMenus.push(articleMenu);

	/**************轮播图****************/
	// let carouselMenu = new Menu("轮播图", "/cgd/by/carousel/list", false, "fa fa-file-image-o");
	// this.byMenus.push(carouselMenu);


	/**************教学团队****************/
	let personMenu = new Menu("教学团队", "/cgd/by/person/list", false, "fa fa-users");
	this.byMenus.push(personMenu);

	/**************视频管理****************/
	let videoMenu = new Menu("视频管理", "/cgd/by/video/list", false, "fa fa-users");
	this.byMenus.push(videoMenu);


	/**************友情链接****************/
	// let blogrollMenu = new Menu("友情链接", "/cgd/by/blogroll/list", false, "fa fa-link");
	// this.byMenus.push(blogrollMenu);

	/**************专题****************/
	let topicManageMenu = new Menu("专题管理", null, false, "fa fa-ravelry");
	this.byMenus.push(topicManageMenu);

	let themeMenu = new Menu("专题样式", "/cgd/by/theme/list", false, "fa fa-signing");
	topicManageMenu.add(themeMenu);

	let customMenu = new Menu("定制页面", "/cgd/by/scenery/list", false, "fa fa-link");
	topicManageMenu.add(customMenu);

	let topicMenu = new Menu("菜单/专题", "/cgd/by/topic/list", false, "fa fa-ravelry");
	topicManageMenu.add(topicMenu);


	/**************网站前台***************/
	let frontendMenu = new Menu("网站前台", "/cgd", false, "fa fa-home");
	this.byMenus.push(frontendMenu);
};

//We use this method to get the full js Object.
User.prototype.render = function (obj) {
	BaseEntity.prototype.render.call(this, obj);


	this.lastTime = str2Date(this.lastTime);

	let role = new UserRole();
	role.render(this.role);
	this.role = role;


	let avatar = new Tank("image", false);
	avatar.render(this.avatar);
	this.avatar = avatar;


	this.refreshMenus();

};

User.prototype.getForm = function () {

	return {
		id: this.id,
		description: this.description,
		avatarCode: this.avatar.code
	};
};

User.prototype.getLoginForm = function () {

	return {
		email: this.email,
		password: this.password,
		token: this.captcha.token,
		captcha: this.captcha.value
	};
};
User.prototype.getRegisterForm = function () {

	return {
		email: this.email,
		phone: this.phone,
		password: this.password,
		nickname: this.nickname,
		token: this.captcha.token,
		captcha: this.captcha.value
	};
};


User.prototype.validate = function () {

	if (!this.email) {
		this.errorMessage = "邮箱必填！";
		return false;
	}

	return true;
};

User.prototype.loginValidate = function () {

	//validate first.
	if (!validateEmail(this.email)) {
		this.errorMessage = "邮箱格式不正确";
		return false;
	}
	if (!this.password) {
		this.errorMessage = "密码必填";
		return false;
	}
	if (this.captcha.visible) {
		if (!this.captcha.value) {
			this.errorMessage = "验证码必填"
			return false;
		}
	}
	return true;
};

User.prototype.registerValidate = function () {

	//validate first.
	if (!validateEmail(this.email)) {
		this.errorMessage = "邮箱格式不正确";
		return false;
	}
	if (!this.nickname) {
		this.errorMessage = "姓名必填";
		return false;
	}
	if (!this.password) {
		this.errorMessage = "密码必填";
		return false;
	}
	if (this.password !== this.repassword) {
		this.errorMessage = "两次密码输入不一致";
		return false;
	}

	return true;
};


//local logout.
User.prototype.logout = function () {
	this.email = null;
	this.password = null;
	this.isLogin = false;
	this.nickname = null;
	this.role = new UserRole();
	delete Vue.http.headers.common['Authorization'];

	//开发阶段不主动移除localStorage信息
	if (!Vue.store.state.debug) {
		window.localStorage.removeItem("user");
	}


};

User.prototype.login = function (response) {
	let that = this;
	that.errorMessage = null;
	that.render(response.data.user);
	that.token = response.data.token;
	that.isLogin = true;
	if (that.token) {
		Vue.http.headers.common['Authorization'] = that.token;
	}

	//sync to localStorage.
	let json = JSON.parse(JSON.stringify(this));
	delete json.byMenus;
	json.isLogin = false;
	window.localStorage.user = JSON.stringify(json);

};

User.prototype.httpLogin = function (successCallback, errorCallback) {


	if (!this.loginValidate()) {
		return;
	}

	let that = this;
	this.httpPost(this.URL_LOGIN, this.getLoginForm(), function (response) {

		that.login(response);

		successCallback && successCallback(response);
	}, errorCallback);
};

User.prototype.httpRegister = function (successCallback, errorCallback) {


	if (!this.registerValidate()) {
		return;
	}

	let that = this;
	this.httpPost(this.URL_REGISTER, this.getRegisterForm(), function (response) {

		that.login(response);

		successCallback && successCallback(response);
	}, errorCallback);
};






// WEBPACK FOOTER //
// ./src/common/model/user/User.js